import React from 'react';

export default props => (
  <svg {...props}>
    {props.children}
    <path d="M6.43944 10.5017L14.4394 1.50171L15.5606 2.49825L8.00347 11L15.5606 19.5017L14.4394 20.4983L6.43944 11.4983C6.18685 11.2141 6.18685 10.7859 6.43944 10.5017Z" />
  </svg>
);
